import { GetterTree } from 'vuex'
import { MapState } from './types'
import { RootState } from '../types'
import { ThingMap } from '@/helpers/objects'

export const getters: GetterTree<MapState, RootState> = {
  map: state => state.map,
  allThings(state): ThingMap {
    return state.things
  },
  currentThings(state): ThingMap {
    return state.entitiesFiltered
  },
  currentMarkers(state): Record<string, any> {
    return state.markers
  },
  getThingsToFollow(state) {
    return state.thingsToFollow
  },
  payloadIsEmpty: state => state.payloadIsEmpty,
  getPondRippleEvent(state) {
    return state.pondRippleEvent
  },
  getStreetViewPanoramaElement: state => state.streetViewPanoramaElement,
  getIsPanoramActive: state => state.isPanoramActive
}
